import { AccordionItem, List, Text, TextLink } from 'braid-design-system';
export const ComplianceWithLawAndTerms = () => (
  <AccordionItem id="compliance" label="Compliance with Law and Terms">
    <List type="number" start={21}>
      <Text>
        You must comply with all applicable laws and these Terms. To the extent
        that they are applicable, your Recruitment Software must also comply
        with the{' '}
        <TextLink href="/support/termsconditions">
          Advertising Terms of Use
        </TextLink>
        .
      </Text>
      <Text>
        In the event of any conflict between the content in these Terms and the
        above documents in relation to the use of the SEEK API, these Terms will
        apply.
      </Text>
    </List>
  </AccordionItem>
);
